import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ConsignmentService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 415
     * @datataskName sp_ws_p2_consignment_assign_sb
     * @param params consignment keyno to assign to.
     * @returns promise containing validation response.
     */
    public async assign(params: ConsignmentAssignParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(415, params))[0];
    }

    /**
     * @datatask 3557
     * @datataskName sp_ws_p2_consignmentline_assign_delete
     * @param params the consignment line keyno to delete consignment assignment from.
     * @returns promise containing validation response.
     */
    public async deleteLineAssignment(params: DeleteConsignmentLineAssignmentParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3557, params))[0];
    }

    /**
     * @datatask 418
     * @datataskName sp_ws_p2_consignment_delivery
     * @param params the consignment to confirm delivery on.
     * @returns promise containing validation response.
     */
    public async confirmDelivery(params: ConsignmentConfirmDeliveryParams): Promise<ConsignmentConfirmDeliveryResponse> {
        return (await this.datatask.Post(418, params))[0];
    }
}

export interface ConsignmentAssignParams {
    consignment_keyno: string | number;
}

export interface DeleteConsignmentLineAssignmentParams {
    consignmentline_keyno: string | number;
}

export interface ConsignmentConfirmDeliveryParams {
    consignment_keyno: string | number;
}

export interface ConsignmentConfirmDeliveryResponse {
    statusid: string;
    validationcode: string;
    validationmessage: string;
}
